import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { StudentAPI } from './AllApi';
import styles from '../components/AdminDashboard.module.css';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';

const AdminDashboard = () => {
  const [students, setStudents] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  //const [emailSentIds, setEmailSentIds] = useState([]);

  const handleLogout = () => {
    navigate('/admin-login');
  };

  const headerStyle = {
    backgroundColor: 'black',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  };

  const logoStyle = {
    height: '40px', 
    width: 'auto',
  };

  const userIconStyle = {
    fontSize: '28px',
    color: '#fff',
    cursor: 'pointer',
  };

  const dropdownStyle = {
    position: 'absolute',
    right: '30px',
    top: '65px',
    backgroundColor: '#fff',
    color: '#000',
    padding: '10px 15px',
    borderRadius: '5px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    zIndex: 1000,
  };

  const fetchStudents = async () => {
    try {
      const response = await fetch(StudentAPI.getAllStudents);
      const data = await response.json();
      setStudents(data);
    } catch (error) {
      toast.error('Error fetching students:', error);
      console.error('Error fetching students:', error);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const filteredStudents = students.filter(
    (student) =>
      student.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      student.email?.toLowerCase().includes(filterText.toLowerCase())
  );

    const handleSendEmail = async (id) => {
    try {
      const response = await fetch(StudentAPI.sendMail(id), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to send email');
      }

      const data = await response.json();
      toast.success(data.message); // This will show "Email sent successfully"
      
    // Add this ID to the list of sent emails
   // setEmailSentIds((prev) => [...prev, id]);
    } catch (error) {
      console.error('Error sending email:', error);
      toast.error('Failed to send email. Please try again.');
    }
  };

  const handleDownload = async () => {
    const excelUrl = StudentAPI.downloadExcel; 
    try {
      const response = await fetch(excelUrl); 

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to download the file.');
      }
     
      window.open(excelUrl, '_blank');  

    } catch (err) {
      toast.error('Error downloading the file. Please try again.');
      console.error("Download Error:", err);
    }
  };

  const columns = [
    {
      name: 'Sr No',
      cell: (row, index) => index + 1,
      width: '70px',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'DOB',
      selector: (row) => {
        const date = new Date(row.dob);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
      width: '100px',
    },    
    {
      name: 'School',
      selector: (row) => row.school,
      wrap: true,
    },
    {
      name: 'Standard',
      selector: (row) => row.standard,
      wrap: true,
    },
    {
      name: 'Parents Name',
      selector: (row) => row.parentName,
      wrap: true,
    },
    {
      name: 'Address',
      selector: (row) => row.address,
      wrap: true,
    },
    {
      name: 'Mobile',
      selector: (row) => row.mobile,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      wrap: true,
    },
    {
    name: 'Actions',
    cell: (row) => (
      <button
        className={styles.emailButton}
        onClick={() => handleSendEmail(row.id)}
    >
    Send Email
    { /* {emailSentIds.includes(row.id) ? 'Sent' : 'Send Email'}*/}
      </button>
    ),
    ignoreRowClick: true,
  },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <header style={headerStyle}>
        <img src="/mmlogo.png" alt="Logo" style={logoStyle} />
        <div>
          <FaUserCircle
            style={userIconStyle}
            onClick={() => setShowLogout((prev) => !prev)}
          />
          {showLogout && (
            <div style={dropdownStyle} onClick={handleLogout}>
              Logout
            </div>
          )}
        </div>
      </header>
  
      <main style={{ flex: 1 }}>
        <div className={styles.dashboardContainer}>
        <div className={styles.headerContainer}>
          <h2 className={styles.heading}>नोंदणीकृत विद्यार्थी यादी</h2>
          <button onClick={handleDownload} className={styles.downloadbtn}>
            Download Excel
          </button>
        </div>

          <input
            className={styles.searchInput}
            type="text"
            placeholder="विद्यार्थीचे नाव किंवा ई-मेल शोधा..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
          <DataTable
            columns={columns}
            data={filteredStudents}
            pagination
            highlightOnHover
            striped
            persistTableHead
            customStyles={customStyles}
            responsive
          />
        </div>
      </main>
  
      <Footer style={{ backgroundColor: '#000', color: '#fff', textAlign: 'center', padding: '10px' }}>
      </Footer>
    </div>
  );
};

const customStyles = {
    headCells: {
      style: {
        backgroundColor: 'black',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
      },
    },
    rows: {
      style: {
        fontSize: '13px',
        minHeight: '40px',
      },
    },
    cells: {
      style: {
        padding: '8px',
      },
    },
    pagination: {
    style: {
      fontSize: "12px",
      backgroundColor: "#f9f9f9",
      color:"black",
      padding: "6px",
      borderRadius: "5px",
      justifyContent: "center",
    },
  },
  };
  
export default AdminDashboard;
